import { render, staticRenderFns } from "./ExportProfiles.vue?vue&type=template&id=0c18dc5c&"
import script from "./ExportProfiles.vue?vue&type=script&lang=js&"
export * from "./ExportProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports